import React from 'react';
import AdUnit from '../AdUnit';

const InArticleAd = () => (
  <AdUnit
    adSlot="2099849374"
    adFormat="horizontal"
  />
);

export default InArticleAd;
